import axiosInstanceV2 from "../config/axios-v2-config";
const BASE_USER_PATH = "/v2/users";
type UserUpdateObject = {
  startDateTime: string;
  endDateTime: string;
  consultingSlot: string;
  timezone: string;
};
export const saveUserAppointmentTimeSlotPreference = async (
  userId: String,
  updateUser: UserUpdateObject
) => {
  try {
    const requestBody = {
      startDateTime: updateUser.startDateTime,
      endDateTime: updateUser.endDateTime,
      consultingSlot: updateUser.consultingSlot,
      timezone: updateUser.timezone,
    };

    const response = await axiosInstanceV2.post(BASE_USER_PATH, requestBody, {
      params: { userId: userId },
    });

    if (response.status !== 201) {
      throw Error("Unable to save or update user info");
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const getUserSettings = async (userId: string) => {
  try {
    const response = await axiosInstanceV2.get(BASE_USER_PATH, {
      params: { userId: userId },
    });
    if (response.status !== 200) {
      throw Error("Unable retrieve user settings data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable retrieve user settings data");
  }
};
